import MentoringManIcon from './MentoringManIcon.vue';

export default MentoringManIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/man/index.ts